import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/slice/authSlice';

const SessionExpiryWarning = () => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [countdown, setCountdown] = useState(3); // 15 seconds countdown

    // Get refresh token from cookies
    const tokenRefresh = Cookies.get('tokenRefresh');
    const tokenAc = Cookies.get('tokenAccess');

    // Decode refresh token and get expiration time
    const getExpirationTime = (token) => {
        if (!token) return null;

        // Decode the JWT token to get the expiration time
        const payload = JSON.parse(atob(token.split('.')[1]));
        const exp = payload.exp * 1000; // Convert to milliseconds
        return exp;
    };

    useEffect(() => {
        const expTime = getExpirationTime(tokenRefresh);
        // console.log('Access Token expires in: ',formatTime(AcexpTime - Date.now()))
        // console.log('Refresh Token expires in: ',formatTime(expTime - Date.now()))
        if (expTime) {
            // Υπολογίστε χρόνο για να εμφανίσετε το modal (10 λεπτά πριν από τη λήξη)
            const timeToShowModal = expTime - Date.now() - (10 * 60 * 1000); // 10 minutes before expiration
            // console.log('Modal show: ',formatTime(timeToShowModal))
            if (timeToShowModal > 0) {
                const timer = setTimeout(() => {
                    setShow(true);
                }, timeToShowModal);

                return () => clearTimeout(timer);
            } else {
                // Εάν απομείνει λιγότερο από 10 λεπτά, δείξτε αμέσως το modal
                setShow(true);
            }
        }
    }, [tokenAc, tokenRefresh]);

    const handleLogout = useCallback(async () => {
        await dispatch(logout({ refresh: tokenRefresh }));
    }, [dispatch, tokenRefresh]);

    useEffect(() => {
        if (show && countdown > 0) {
            const countdownTimer = setInterval(() => {
                setCountdown(prev => prev - 1);
            }, 1000);

            if (countdown === 1) {
                handleLogout();
            }

            return () => clearInterval(countdownTimer);
        }
    }, [show, countdown, handleLogout]);


    return (
        <>
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>Προειδοποίηση λήξης συνεδρίας</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Η συνεδρία σας θα λήξει σε {countdown} δευτερόλεπτα. Παρακαλούμε συνδεθείτε ξανά για να συνεχίσετε τις δραστηριότητές σας.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleLogout}>
                        <strong>Συνδεθείτε ξανά</strong>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SessionExpiryWarning;
